export const useInChina = () => {
  return window.KALO_DATA?.reqCountry === "China" || window.KALO_DATA?.reqCountry === "Hong Kong";
};

export const useInChinaMainland = () => {
  return window.KALO_DATA?.reqCountry === "China";
};

export const useInUnitedStates = () => {
  return window.KALO_DATA?.reqCountry === "United States";
};

export const useInChinaOrSingapore = () => {
  return window.KALO_DATA?.reqCountry === "Singapore" || window.KALO_DATA?.reqCountry === "China";
};

export const getCopyRight = () => {
  return window.KALO_DATA?.copyright;
};
